module.exports = __webpack_public_path__ + "static/media/portal-showcase.56ccd2d6.mov";